<template>
  <v-container>
    <v-dialog
        v-model="treatmentDialog"
      
        max-width="600"
    >
    <v-form ref="treatmentForm" v-model="treatmentValid" lazy-validation @submit.prevent="submitTreatment">
      <v-card class="custom-card" rounded="0">
            <v-toolbar   color="primary"
              dark class="text-h6">
              Add New Treatment
            </v-toolbar>
            <!-- <v-card-text>
               asdasd
            </v-card-text> -->
            <div class="px-5 py-5">
        
              <v-row>
                <v-col class="py-0" sm="6">
                  <label class="label">Treatment</label>
                  <v-text-field
                        outlined
                        placeholder="Type Treatment Name"
                        dense
                        v-model="treatmentData.treatment_name"
                      ></v-text-field>
                </v-col>
                <!-- <v-col class="py-0" sm="6">
                  <label class="label">Reason of Treatment</label>
                  <v-text-field
                        outlined
                        placeholder="Type Treatment Reason "
                        dense
                        v-model="treatmentData.reason_of_treatment"
                      ></v-text-field>
                </v-col> -->
              </v-row>
              <v-row>
                <v-col class="py-0" sm="6">
                   <label class="label">Date</label>
                   <v-menu
                      v-model="treatmentDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="treatmentData.treatment_date"
                          append-icon="mdi-calendar"
                          outlined
                          dense
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          v-on:click:append="treatmentDateMenu=true"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="treatmentData.treatment_date"
                        @input="treatmentDateMenu = false"
                      ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col class="py-0" sm="6">
                   <label class="label">Diagnosis</label>
                  <v-text-field
                        outlined
                        placeholder="Type Name of Diagnosis"
                        dense
                        v-model="treatmentData.name_of_diagnosis"
                      ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" sm="6">
                   <label class="label">Drug ID</label>
                  <v-text-field
                        outlined
                        placeholder="Enter Drug ID"
                        dense
                        v-model="treatmentData.drugId"
                      ></v-text-field>
                </v-col>
                <v-col class="py-0" sm="6">
                   <label class="label">Drug Name</label>
                  <v-text-field
                        outlined
                        placeholder="Type Name of the Drug"
                        dense
                        v-model="treatmentData.treatment_drug_name"
                      ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" sm="3">
                   <label class="label">Drug Withdrawal Period</label>
                  <v-text-field
                        outlined
                        placeholder="Enter Value"
                        dense
                        type="number"
                        v-model="treatmentData.drug_withdrawal_period"
                      ></v-text-field>
                </v-col>
                <v-col class="py-0" sm="3">
                  <label class="label"> {{"."}}</label>
                  <v-select
                        outlined
                        placeholder="Select Units"
                        dense
                        v-model="treatmentData.drug_withdrawal_period_unit"
                        :items="withdrawPeriodUnitsOptions"
                      ></v-select>
                </v-col>
                <v-col class="py-0" sm="6">
                  <label class="label">Attending Veterinarian</label>
                  <v-text-field
                        outlined
                        placeholder="Type Attending Veterinarian"
                        dense
                        v-model="treatmentData.attending_vetenarian"
                      ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" sm="6">
                   <label class="label">Pack ID</label>
                  <v-text-field
                        outlined
                        placeholder="Enter Pack ID"
                        dense
                        v-model="treatmentData.packId"
                      ></v-text-field>
                </v-col>
             
              </v-row>
      </div>
      <v-divider></v-divider>
            <v-card-actions class="pb-5">
                <v-spacer></v-spacer>
                <v-btn
                    color="green darken-1"
                    outlined
                    @click="treatmentDialog = false"
            
                >
                 {{ $t("cancel") }} 
                </v-btn>
                <v-btn
                    depressed
                    color="primary"
                    type="submit"
                >
                Submit 
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-form>

    </v-dialog>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="updateHealthRecord">
      <v-card flat class="mt-7 pa-5">
        <v-toolbar flat width="100%">
          <v-toolbar-title class="text-h4">{{$t('animal.healthRecord')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            @click="cancelpage"
            outlined
            right
            height="44"
            width="116"
            color="primary"
          >
            {{$t('cancel')}}
          </v-btn>
          <v-btn
            right
            class="ml-5"
            height="44"
            width="116"
            color="primary"
            type="submit"
          >
            {{$t('submit')}}
          </v-btn>
        </v-toolbar>
      </v-card>
      <v-card>
        <v-tabs v-model="healthTabs" background-color="primary" dark>
          <v-tab>
            Treatment
          </v-tab>
          <v-tab>
      
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="healthTabs">
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                
                <!-- treatment tab -->
            <v-row>
              <v-col sm="3"  class="text-h6 font-weight-bold">
                Treatment
              </v-col>
              <v-col sm ="3"></v-col>
              <v-col sm="3">
                <v-btn
                color="primary"
                outlined
              
                >EDIT CURRENT RECORD</v-btn>
              </v-col>
              <v-col sm="3">
                <v-btn
                @click="treatmentDialog = true"
                  dense
                  color="primary"
                >{{ this.$t('addNewRecord') }}</v-btn>
              </v-col>
            </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item>
            <v-card flat>
              <v-card-text>asdas123d</v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
      <v-expansion-panels focusable class="mt-5" v-model="panel">
        <!-- parasite control -->
        <v-expansion-panel>
          <v-expansion-panel-header class="text-h6 font-weight-bold"
            >{{$t('animal.healthRecordInfo.parasiteControl')}}</v-expansion-panel-header
          >
          <v-expansion-panel-content class="pt-5">
            <v-row>
              <v-col cols="4">
                <label class="label">{{$t('animal.healthRecordInfo.date')}}</label>
                <v-menu
                  v-model="parasiteDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="animalHealth.parasiteDate"
                      append-icon="mdi-calendar"
                      outlined
                      dense
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      v-on:click:append="parasiteDateMenu=true"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="animalHealth.parasiteDate"
                    @input="parasiteDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="4">
                <label class="label">{{$t('animal.healthRecordInfo.purpose')}}
           
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      The main reason why there is parasite control schedule e.g. Deworming.Internal parasites include roundworms (nematodes), tapeworms (cestodes), flukes (trematodes) and protozoans (such as coccidia).
                      The major external parasites that affect animals include flies, grubs, lice, ticks, and mites. These external parasites feed on body tissues such as blood and skin, and in addition they cause irritation and discomfort that result in reduced weight gain and lost production. Parasites that take blood meals have the potential to serve as vectors for the transmission of diseases.
                    </span>
                  </v-tooltip>
                
                </label>
                <v-select
                  v-model="animalHealth.purpose"
                  :items="purposes"
                  outlined
                  dense
                ></v-select>
              </v-col>
              <v-col cols="4">
                <label class="label">{{$t('animal.healthRecordInfo.drugName')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      Example Dicloxacillin,Tylosin, Erythromycin or Cloxacillin for mastitis
                    </span>
                  </v-tooltip>
                </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="$t('animal.healthRecordInfo.drugName')"
                  v-model="animalHealth.parasiteDrugName"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <label class="label">{{$t('animal.healthRecordInfo.dose')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      Example- dose rate of 12.5 mg/kg
                    </span>
                  </v-tooltip>
                </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="$t('animal.healthRecordInfo.dose')"
                  v-model="animalHealth.dose"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <label class="label">{{$t('animal.healthRecordInfo.withdrawalPeriod')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      eg;60 days
                    </span>
                  </v-tooltip>
                </label>
                <v-text-field
                  type="number"
                  :min="0"
                  outlined
                  dense
                  placeholder="2 days"
                  v-model="animalHealth.withdrawalPeriod"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <label class="label">{{$t('animal.healthRecordInfo.routeOfAdministration')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      The location at which the drug is administered, such as oral, sublingual, rectal, topical.
Parenteral (intravenous, intramuscular, subcutaneous.) 
                    </span>
                  </v-tooltip>
                </label>
                <v-select
                  v-model="animalHealth.routeOfAdministration"
                  :items="routeOfAdministrations"
                  :error-messages="errors.routeOfAdministration" :rules="routeOfAdministrationRules.routeOfAdministration"
                  outlined
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12">
                <label class="label">{{$t('animal.healthRecordInfo.notes')}}</label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  placeholder="Enter remarks"
                  v-model="animalHealth.remarks"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- diseases -->
        <v-expansion-panel>
          <v-expansion-panel-header class="text-h6 font-weight-bold"
            >{{$t('animal.healthRecordInfo.disease')}}</v-expansion-panel-header
          >
          <v-expansion-panel-content class="pt-5">
            <v-row>
              <v-col cols="4">
                <label class="label">
                  {{$t('animal.healthRecordInfo.clinicalSymptoms')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      Observable e.g. diarrhea, limping, bloody discharge, salivation, blindness, abortions
                    </span>
                  </v-tooltip>
                </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="$t('animal.healthRecordInfo.clinicalSymptoms')"
                  v-model="animalHealth.clinicalSymptoms"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <label class="label">
                  {{$t('animal.healthRecordInfo.tentativeDiagnosis')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      A tentative diagnosis is a diagnosis that can neither be confirmed or a conclusion can be made. While they may suspect, and have good background history to support it, it's not a confirmed diagnosis until all the results are in. No doctor is going to give you a diagnosis when they need more information (most of the time blood tests or body scans). It will be a tentative diagnosis until then.
                    </span>
                  </v-tooltip>
                </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="$t('animal.healthRecordInfo.tentativeDiagnosis')"
                  v-model="animalHealth.tentativeDiagnosis"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <label class="label">
                  {{$t('animal.healthRecordInfo.sampleCollected')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      Sample collected to make definite diagnosis e.g. blood, urine, skin scrap, milk
                    </span>
                  </v-tooltip>
                </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="$t('animal.healthRecordInfo.sampleCollected')"
                  v-model="animalHealth.sampleCollected"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <label class="label">
                  {{$t('animal.healthRecordInfo.date')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t("animal.healthRecordInfo.date")
                    }}</span>
                  </v-tooltip>
                </label>
                <v-menu
                  v-model="diseaseDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="animalHealth.diseaseDate"
                      append-icon="mdi-calendar"
                      outlined
                      dense
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      v-on:click:append="diseaseDateMenu=true"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="animalHealth.diseaseDate"
                    @input="diseaseDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="4">
                <label class="label">
                  {{$t('animal.healthRecordInfo.veterinarianName')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t("animal.healthRecordInfo.veterinarianName")
                    }}</span>
                  </v-tooltip>
                </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="$t('animal.healthRecordInfo.veterinarianName')"
                  v-model="animalHealth.veterinarianName"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- treatment -->
        <v-expansion-panel>
          <v-expansion-panel-header class="text-h6 font-weight-bold"
            >{{$t('animal.healthRecordInfo.treatment')}}</v-expansion-panel-header
          >
          <v-expansion-panel-content class="pt-5">
            <v-row>
              <v-col cols="6">
                <label class="label">
                  {{$t('animal.healthRecordInfo.treatment')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{$t("animal.healthRecordInfo.treatmentDetail")}}
                    </span>
                  </v-tooltip>
                </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="$t('animal.healthRecordInfo.treatment')"
                  v-model="animalHealth.treatmentName"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <label class="label">
                  {{$t('animal.healthRecordInfo.reasonOfTreatment')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{$t("animal.healthRecordInfo.reasonOfTreatmentDetail")}}
                    </span>
                  </v-tooltip>
                </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="$t('reason')"
                  v-model="animalHealth.reasonOfTreatment"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <label class="label">
                  {{$t('animal.healthRecordInfo.treatmentDate')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{$t("animal.healthRecordInfo.treatmentDateDetail")}}
                    </span>
                  </v-tooltip>
                </label>
                <v-menu
                  v-model="treatmentDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="animalHealth.treatmentDate"
                      append-icon="mdi-calendar"
                      outlined
                      dense
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="animalHealth.treatmentDate"
                    @input="treatmentDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <label class="label">
                  {{$t('animal.healthRecordInfo.diagnosis')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{$t("animal.healthRecordInfo.diagnosisDetail")}}
                    </span>
                  </v-tooltip>
                </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="$t('animal.healthRecordInfo.diagnosis')"
                  v-model="animalHealth.diagnosisName"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <label class="label">
                  {{$t('animal.healthRecordInfo.drugName')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{$t("animal.healthRecordInfo.drugNameDetail")}}
                    </span>
                  </v-tooltip>
                </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="$t('animal.genotypeDataInfo.nameOfTheDrug')"
                  v-model="animalHealth.drugName"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <label class="label">
                  {{$t('animal.healthRecordInfo.drugWithdrawalPeriod')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{$t("animal.healthRecordInfo.drugWithdrawalperiodDetail")}}
                    </span>
                  </v-tooltip>
                </label>
                <v-text-field
                  type="number"
                  outlined
                  dense
                  :placeholder="`2 ${$t('days')}`"
                  v-model="animalHealth.drugWithdrawlPeriod"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <label class="label">
                  {{$t('animal.healthRecordInfo.attendingVeterinarian')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{$t("animal.healthRecordInfo.attendingVeterinarianDetail")}}
                    </span>
                  </v-tooltip>
                </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="$t('animal.healthRecordInfo.veterinarianName')"
                  v-model="animalHealth.attendingVeterinarian"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <label class="label">
                  {{$t('animal.healthRecordInfo.packID')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{$t("animal.healthRecordInfo.packIdDetail")}}
                    </span>
                  </v-tooltip>
                </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  placeholder="#PACK28716"
                  v-model="animalHealth.packId"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <label class="label">
                  {{$t('animal.healthRecordInfo.treatmentStartDate')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{$t('animal.healthRecordInfo.treatmentStartDate')}}
                    </span>
                  </v-tooltip>
                </label>
                <v-menu
                  v-model="treatmentStartingDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="animalHealth.treatmentStartDate"
                      append-icon="mdi-calendar"
                      outlined
                      dense
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="animalHealth.treatmentStartDate"
                    @input="treatmentStartingDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="4">
                <label class="label">
                  {{$t('animal.healthRecordInfo.treatmentEndDate')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{$t('animal.healthRecordInfo.treatmentEndDate')}}
                    </span>
                  </v-tooltip>
                </label>
                <v-menu
                  v-model="treatmentEndingDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="animalHealth.treatmentEndDate"
                      append-icon="mdi-calendar"
                      outlined
                      dense
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="animalHealth.treatmentEndDate"
                    @input="treatmentEndingDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="4">
                <label class="label">{{$t('animal.healthRecordInfo.prognosis')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{$t('animal.healthRecordInfo.prognosisDetail')}}
                    </span>
                  </v-tooltip>
                </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  v-model="animalHealth.prognosis"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- vaccination -->
        <v-expansion-panel>
          <v-expansion-panel-header class="text-h6 font-weight-bold"
            >{{$t('animal.healthRecordInfo.vaccination')}}</v-expansion-panel-header
          >
          <v-expansion-panel-content class="pt-5">
            <v-row>
              <v-col cols="4">
                <label class="label">
                  {{$t('animal.healthRecordInfo.vaccinationType')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{$t('animal.healthRecordInfo.vaccinationType')}}
                    </span>
                  </v-tooltip>
                </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="$t('animal.healthRecordInfo.vaccinationType')"
                  v-model="animalHealth.vaccinationType"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <label class="label">
                  {{$t('animal.healthRecordInfo.vaccinationName')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{$t('animal.healthRecordInfo.vaccinationName')}}
                    </span>
                  </v-tooltip>
                </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="$t('animal.healthRecordInfo.vaccinationName')"
                  v-model="animalHealth.vaccinationName"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <label class="label">
                  {{$t('animal.healthRecordInfo.vaccinationAge')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{$t('animal.healthRecordInfo.vaccinationAge')}}
                    </span>
                  </v-tooltip>
                </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="$t('animal.healthRecordInfo.vaccinationAge')"
                  v-model="animalHealth.vaccinationAge"
                ></v-text-field>
                <v-menu
                  v-model="vaccinationAgeDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="animalHealth.vaccinationAge"
                      append-icon="mdi-calendar"
                      outlined
                      dense
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="animalHealth.vaccinationAge"
                    @input="vaccinationAgeDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="4">
                <label class="label">
                  {{$t('animal.healthRecordInfo.immunityAfterVaccination')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{$t('animal.healthRecordInfo.immunityAfterVaccination')}}
                    </span>
                  </v-tooltip>
                </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="$t('animal.healthRecordInfo.immunityAfterVaccination')"
                  v-model="animalHealth.immunityAfterVaccination"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <label class="label">
                  {{$t('animal.healthRecordInfo.immunityLastingPeriod')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{$t('animal.healthRecordInfo.immunityLastingPeriod')}}
                    </span>
                  </v-tooltip>
                </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="$t('animal.healthRecordInfo.immunityLastingPeriod')"
                  v-model="animalHealth.immunityLastingPeriod"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <label class="label">
                  {{$t('animal.healthRecordInfo.routeOfAdministration')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{$t('animal.healthRecordInfo.routeOfAdministration')}}
                    </span>
                  </v-tooltip>
                </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="$t('animal.healthRecordInfo.routeOfAdministration')"
                  v-model="animalHealth.vaccineRouteOfAdmin"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <label class="label">
                  {{$t('animal.healthRecordInfo.vaccinationDosage')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{$t('animal.healthRecordInfo.vaccinationDosage')}}
                    </span>
                  </v-tooltip>
                </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="$t('animal.healthRecordInfo.vaccinationDosage')"
                  v-model="animalHealth.vaccinationDosage"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <label class="label">
                  {{$t('animal.healthRecordInfo.revaccinationTime')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{$t('animal.healthRecordInfo.revaccinationTime')}}
                    </span>
                  </v-tooltip>
                </label>
                <v-menu
                  v-model="revaccinationtDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="animalHealth.revaccinationtDate"
                      append-icon="mdi-calendar"
                      outlined
                      dense
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="animalHealth.revaccinationtDate"
                    @input="revaccinationtDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="4">
                <label class="label">
                  {{$t('animal.healthRecordInfo.vaccinationDate')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{$t('animal.healthRecordInfo.vaccinationDate')}}
                    </span>
                  </v-tooltip>
                </label>
                <v-menu
                  v-model="vaccinationtDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="animalHealth.vaccinationtDate"
                      append-icon="mdi-calendar"
                      outlined
                      dense
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="animalHealth.vaccinationtDate"
                    @input="vaccinationtDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="4">
                <label class="label">
                  {{$t('animal.healthRecordInfo.administratorName')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{$t('animal.healthRecordInfo.administratorName')}}
                    </span>
                  </v-tooltip>
                </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="$t('animal.healthRecordInfo.administratorName')"
                  v-model="animalHealth.administratorName"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <div class="d-flex justify-end">
        <v-btn
          @click="cancelpage"
          outlined
          right
          height="44"
          width="116"
          color="primary"
          class="mr-2 mt-15"
        >
          {{$t('cancel')}}
        </v-btn>
        <v-btn
          right
          class="mt-15"
          height="44"
          width="116"
          color="primary"
          type="submit"
        >
          {{$t('submit')}}
        </v-btn>
      </div>
    </v-form>
  </v-container>
</template>

<script>
// import { weightUnits, milkUnits, birthEaseTypes, totalLongevity, timeUnits } from "@/models/units.js"

import loading from "@/mixins/LoadingMixin";

import gql from 'graphql-tag';
import moment from 'moment';

export default {
  computed: {
    purposes() {
      return [
        'Deworming',
        'External Parasite',
        'Extendo Parasites',
      ]
    },
    routeOfAdministrations() {
      return [
        'Oral',
        'Sublingual',
        'Intragastric gavage',
        'Rectal',
      ];
    }
  },

  data() {
    return {
      treatmentValid: false,
      withdrawPeriodUnitsOptions: [
        {text: 'Hours', value: 'hours'},
        {text: 'Days', value: 'days'},
        {text: 'Weeks', value: 'weeks'},
      ],
      treatmentData: {
        drug_withdrawal_period_unit: "days"
      },
      treatmentDialog: false,
      healthTabs: "",
      animalHealth: {},
      errors: {
        routeOfAdministration: '',
      },
      panel: 0,
      diseaseDateMenu: false,
      parasiteDateMenu: false,
      treatmentDateMenu: false,
      treatmentEndingDateMenu: false,
      treatmentStartingDateMenu: false,
      revaccinationtDateMenu: false,
      vaccinationtDateMenu: false,
      treatmentVaccinationAgeDateMenu: false,
      routeOfAdministrationRules: {
        routeOfAdministration: [(v) => !!v || "Route of Administration is required"],
      },
      treatmentRules: {

      },
      valid: true,
    };
  },
  methods: {
    async submitTreatment() {
      console.log(this.$refs.treatmentForm.validate(), 'validate treatment')
      console.log(this.treatmentData, 'treat data')
      console.log(this.$route.params.animal_number, 'this.$route.params.animal_number')
      let formData = {}
      formData = this.treatmentData
      formData.animalId = Number(this.$route.params.animal_number)
      this.startLoading();
      try {
        await this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation ($data: CreateHealthTreatmentInput!) {
              createHealthTreatment(CreateHealthTreatmentInput: $data) {
                id
              }
            }
          `,
          // Parameters
          variables: {
            data: formData,
          },
        })
      } catch (error) {
        this.stopLoading();
      }
      this.stopLoading();
 
    },
    cancelpage() {
      this.$emit('health:close');
    },

    updateHealthRecord() {
      if (!this.$refs.form.validate()) return;
      this.startLoading();

      const mutation = this._animalHealth && this._animalHealth.id
        ? `mutation ($data: UpdateHealthInput!) {
            updateHealth (updateHealthInput: $data) {
              id
            }
          }`
        : `mutation ($data: CreateHealthInput!) {
            createHealth (createHealthInput: $data) {
              id
            }
          }`;

      this.$apollo.mutate({
        mutation: gql`${mutation}`,
        variables: {
          data: {
            id: this.animalHealth.id,
            animalId: parseInt(this.$route.params.animal_number),

            parasite_date: this.animalHealth.parasiteDate ? moment(this.animalHealth.parasiteDate).format('YYYY-MM-DD') : null,
            purpose: this.animalHealth.purpose,
            parasite_drug_name: this.animalHealth.parasiteDrugName,
            dose: this.animalHealth.dose,
            withdrawal_period: parseInt(this.animalHealth.withdrawalPeriod),
            route_of_administration: this.animalHealth.routeOfAdministration,
            remarks: this.animalHealth.remarks,

            clinical_symptoms: this.animalHealth.clinicalSymptoms,
            tentative_diagnosis: this.animalHealth.tentativeDiagnosis,
            sample_collected: this.animalHealth.sampleCollected,
            disease_date: this.animalHealth.diseaseDate ? moment(this.animalHealth.diseaseDate).format('YYYY-MM-DD') : null,
            veterinarian_name: this.animalHealth.veterinarianName,

            treatment_name: this.animalHealth.treatmentName,
            reason_of_treatment: this.animalHealth.reasonOfTreatment,
            name_of_diagnosis: this.animalHealth.diagnosisName,
            treatment_date: this.animalHealth.treatmentDate ? moment(this.animalHealth.treatmentDate).format('YYYY-MM-DD') : null,
            treatment_drug_name: this.animalHealth.drugName,
            drug_withdrawal_period: parseInt(this.animalHealth.drugWithdrawlPeriod),
            attending_vetenarian: this.animalHealth.attendingVeterinarian,
            pack_id: this.animalHealth.packId ? parseInt(this.animalHealth.packId) : null,
            treatment_start_date: this.animalHealth.treatmentStartDate ? moment(this.animalHealth.treatmentStartDate).format('YYYY-MM-DD') : null,
            treatment_end_date: this.animalHealth.treatmentEndDate ? moment(this.animalHealth.treatmentEndDate).format('YYYY-MM-DD') : null,
            prognosis: this.animalHealth.prognosis,
            
            administrator_name: this.animalHealth.administratorName,
            vaccination_age: this.animalHealth.vaccinationAge,
            vaccination_date: this.animalHealth.vaccinationtDate ? moment(this.animalHealth.vaccinationtDate).format('YYYY-MM-DD') : null,
            vaccination_dosage: this.animalHealth.vaccinationDosage,
            vaccination_name: this.animalHealth.vaccinationName,
            vaccination_type: this.animalHealth.vaccinationType,
            vaccine_route_of_admin: this.animalHealth.vaccineRouteOfAdmin,
            revaccination_time: this.animalHealth.revaccinationtDate ? moment(this.animalHealth.revaccinationtDate).format('YYYY-MM-DD') : null,
            immunity_after_vaccination: this.animalHealth.immunityAfterVaccination,
            immunity_lasting_period: this.animalHealth.immunityLastingPeriod,

            userId: parseInt(this.$store.getters.getUser.id),
          },
        },
      })
        .then((res) => {
          let msg = "added";

          if (this.animalHealth.id) {
            msg = "updated";
          }
          if (res.data.updateHealth || res.data.createHealth) {
            this.$notify({
              title: `Animal health record ${msg} successfully`,
              text: res.message,
              type: "success",
              position: "top right",
            });

            this.$emit('health:updated');
          } else {
            this.$notify({
              title: `Animal Health Record Not ${msg}`,
              text: res.message,
              type: "error",
              position: "top right",
            });
          }
          this.stopLoading();
          this.cancelpage();
        })
        .catch((err) => {
          console.log(err.data);
          this.stopLoading();
        });
    },
  },
  mixins: [loading],
  mounted() {
    if (this._animalHealth) {
      this.animalHealth = Object.assign({}, {
        ...this._animalHealth,
        parasiteDate: this._animalHealth.parasiteDate ? moment(this._animalHealth.parasiteDate).format('YYYY-MM-DD') : null,
        diseaseDate: this._animalHealth.diseaseDate ? moment(this._animalHealth.diseaseDate).format('YYYY-MM-DD') : null,
        treatmentDate: this._animalHealth.treatmentDate ? moment(this._animalHealth.treatmentDate).format('YYYY-MM-DD') : null,
        treatmentStartDate: this._animalHealth.treatmentStartDate ? moment(this._animalHealth.treatmentStartDate).format('YYYY-MM-DD') : null,
        treatmentEndDate: this._animalHealth.treatmentEndDate ? moment(this._animalHealth.treatmentEndDate).format('YYYY-MM-DD') : null,
        vaccinationtDate: this._animalHealth.vaccinationtDate ? moment(this._animalHealth.vaccinationtDate).format('YYYY-MM-DD') : null,
        revaccinationtDate: this._animalHealth.revaccinationtDate ? moment(this._animalHealth.revaccinationtDate).format('YYYY-MM-DD') : null,
        drugWithdrawlPeriod: this._animalHealth.drugWithdrawalPeriod ? parseInt(this._animalHealth.drugWithdrawalPeriod) : null,
      });
    }
  },
  props: {
    _animalHealth: {
      required: true,
      type: Object,
    }
  },
};
</script>
<style lang="scss" scopped>
label {
  display: inline-block;
  margin-bottom: 0.5rem;
  font-size: 14px;
  font-family: Poppins-Medium;
  letter-spacing: 0.5px;
  white-space: nowrap;
}
</style>